import Cookies from 'js-cookie';

const CookieFunctions = (function () {

    var expiration = 8 / 24; //8h -> same as webapi expiration 

    var getFirstName = function () {
        try {
            return JSON.parse(Cookies.get('firstName'));
        } catch {
            return "";
        }
    };

    var setFirstName = function (newFirstName) {
        Cookies.set("firstName", JSON.stringify(newFirstName), { expires: expiration });
    };

    var getLastName = function () {
        try {
            return JSON.parse(Cookies.get('lastName'));
        } catch {
            return "";
        }
    };

    var setLastName = function (newFirstName) {
        Cookies.set("lastName", JSON.stringify(newFirstName), { expires: expiration });
    };

    var getDriverType = function () {
        try {
            return JSON.parse(Cookies.get('driverType'));
        } catch {
            return "";
        }
    };

    var setDriverType = function (newFirstName) {
        Cookies.set("driverType", JSON.stringify(newFirstName), { expires: expiration });
    };

    var getCountry = function () {
        try {
            return JSON.parse(Cookies.get('country'));
        } catch {
            return "";
        }
    };

    var setCountry = function (newFirstName) {
        Cookies.set("country", JSON.stringify(newFirstName), { expires: expiration });
    };

    var getJWTToken = function () {
        try {
            return JSON.parse(Cookies.get('jwtToken'));
        } catch {
            return "";
        }
    };

    var setJWTToken = function (jwtToken) {
        Cookies.set("jwtToken", JSON.stringify(jwtToken), { expires: expiration }); // set the expiration for the token for 30 mins

    };

    var getRole = function () {
        try {
            return JSON.parse(Cookies.get('role'));
        } catch {
            return "";
        }
    };

    var setRole = function (role) {
        Cookies.set("role", JSON.stringify(role), { expires: expiration }); // set the expiration for the token for 30 mins

    };

    var getStatus = function () {
        try {
            return JSON.parse(Cookies.get('status'));
        } catch {
            return "";
        }
    };

    var setStatus = function (newStatus) {
        Cookies.set("status", JSON.stringify(newStatus), { expires: expiration });
    };

    var getHireDate = function () {
        try {
            return JSON.parse(Cookies.get('mpp_hiredate'));
        } catch {
            return "";
        }
    };

    var setHireDate = function (hiredate) {
        Cookies.set("mpp_hiredate", JSON.stringify(hiredate), { expires: expiration });
    };

    var getMfaToken = function () {
        try {
            return JSON.parse(Cookies.get('mfa'));
        } catch {
            return "";
        }
    }

    var setMfaToken = function (token) {
        Cookies.set("mfa", JSON.stringify(token), { expires: 7 }); // Set MFA token to last for 7 days
    }

    var logout = function () {
        Cookies.remove('jwtToken');
        Cookies.remove('firstName');
        Cookies.remove('lastName');
        Cookies.remove('driverType');
        Cookies.remove('country');
        Cookies.remove('role');
        Cookies.remove('status');
        Cookies.remove('mpp_hiredate');
    }

    return {
        getFirstName: getFirstName,
        setFirstName: setFirstName,
        getLastName: getLastName,
        setLastName: setLastName,
        getDriverType: getDriverType,
        setDriverType: setDriverType,
        getCountry: getCountry,
        setCountry: setCountry,
        getJWTToken: getJWTToken,
        setJWTToken: setJWTToken,
        getRole: getRole,
        setRole: setRole,
        getStatus: getStatus,
        setStatus: setStatus,
        getHireDate: getHireDate,
        setHireDate: setHireDate,
        getMfaToken: getMfaToken,
        setMfaToken: setMfaToken,
        logout: logout,
    }

})();

export default CookieFunctions;